import { Component } from '@angular/core';
import {
	FormConfig,
	CustomFormAccessor,
} from 'src/shared/form-models/form-cva.component';
import { Validators, NgControl, FormBuilder } from '@angular/forms';
import { CustomerDetailGeneralInformation } from '../customer-detail.models';

const customerGeneralInfoFormConfig: FormConfig<CustomerDetailGeneralInformation> = {
	id: [''],
	companyName: ['', [Validators.required]],
	employerIdentificationNumber: [''],
	billingEmail: ['', [Validators.required, Validators.email]],
	flairDocsCustomerId: [''],
};

@Component({
	selector: 'rpfsa-customer-general-info',
	templateUrl: './general-info.component.html',
})
export class CustomerDetailGeneralInfoComponent extends CustomFormAccessor<
	CustomerDetailGeneralInformation
> {
	isFlairdocsCustomer: boolean;

	constructor(public ngControl: NgControl, public fb: FormBuilder) {
		super(ngControl, fb, customerGeneralInfoFormConfig);
	}

	// model --> view
	writeValue(value: CustomerDetailGeneralInformation): void {
		if (value) {
			this.form.patchValue(value, { emitEvent: false });
			this.form.markAsUntouched();
			this.isFlairdocsCustomer = !!value.flairDocsCustomerId;
		}
	}
}
